<template>
  <div>
    <div class="ned01">
      <div class="ned02">
        <p class="ned03">{{data.title}}</p>
        <div class="ned04" v-html="data.content">
          {{data.content}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from '@/api/user';
  export default {
    name: "detail",
    data(){
      return{
        data:[]
      }
    },
    created() {
      me = this;
      user =  JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      let data = {
        'id':me.$route.query.id,
      }
      httpUser.newslist(data).then(res => {
        me.data = res.data.dataList[0];
        console.log(me.data);
      })
    },
    methods:{

    }
  }
</script>

<style scoped>
@import "../main.css";
</style>